module.exports = __webpack_public_path__ + "static/img/02.49d1d22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/gamify/tutorial/02.svg
// module id = eXCa
// module chunks = 13